import { render, staticRenderFns } from "./createIndex.vue?vue&type=template&id=52f4b9fa&scoped=true"
import script from "./createIndex.vue?vue&type=script&lang=js"
export * from "./createIndex.vue?vue&type=script&lang=js"
import style0 from "./createIndex.vue?vue&type=style&index=0&id=52f4b9fa&prod&lang=scss&scoped=true"
import style1 from "./createIndex.vue?vue&type=style&index=1&id=52f4b9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4b9fa",
  null
  
)

export default component.exports